// Import to local collection
// import * as backendFunc from 'GesagtGetan.Basic/Resources/Private/Assets/Backend';

// Import just the needed functions
// import { NeosEvents } from 'GesagtGetan.Basic/Resources/Private/Assets/Backend';

import ButtonContextBar from "./ButtonContextBar";
import NeosEvents from "./NeosEvents";
import GetBackendLanguageCode from "./GetBackendLanguageCode";

NeosEvents("ContentModuleLoaded", () => {
    document.documentElement.setAttribute(
        "data-lang",
        GetBackendLanguageCode()
    );
});

if (typeof _gg == "object") {
    _gg.NeosEvents = NeosEvents;
}

export { ButtonContextBar, GetBackendLanguageCode, NeosEvents };
